import { AxiosRequestHeaders } from 'axios';
import { capability } from '../rpc-client/config/capabilities';
import RpcClientFactory from '../rpc-client/factory/rpc-client-factory';
import { DtoTypes } from '..';

export async function getAccountLobSummaryTop(
    params: string[],
    headers: AxiosRequestHeaders = {}
): Promise<DtoTypes.PC.top.edge.capabilities.policy.lobsummary.dto.LobSummaryBaseDTO[]> {
    return await RpcClientFactory.getInstance().rpcCall<
        DtoTypes.PC.top.edge.capabilities.policy.lobsummary.dto.LobSummaryBaseDTO[]
    >(capability.PC_POLICY, 'getAccountLobSummaryTop', [params], headers);
}

export async function getAccountPolicyDetails(
    policyNumber: string,
    callConfig: DtoTypes.PC.top.edge.capabilities.policycommon.ProgressiveCallConfigDTO = {},
    headers: AxiosRequestHeaders = {}
): Promise<DtoTypes.PC.edge.capabilities.policy.dto.PolicyDetailsDTO> {
    return await RpcClientFactory.getInstance().rpcCall<DtoTypes.PC.edge.capabilities.policy.dto.PolicyDetailsDTO>(
        capability.PC_POLICY,
        'getAccountPolicyDetailsProgressive_Top',
        [policyNumber, callConfig],
        headers
    );
}

export async function getCarGreenCard(
    policyNumber: string,
    carId: string,
    headers: AxiosRequestHeaders = {}
): Promise<string> {
    return await RpcClientFactory.getInstance().rpcCall<string>(
        capability.PC_POLICY,
        'getCarGreenCard',
        [policyNumber, carId],
        headers
    );
}
